import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxSignPdfComponent } from './ngx-sign-pdf/ngx-sign-pdf.component';
import { ModalComponent } from './modal/modal.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SelectionAreaComponent } from './selection-area/selection-area.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { HeaderComponent } from './components/header/header.component';
import { SideNavContentComponent } from './components/side-nav-content/side-nav-content.component';
import { HttpClientModule } from "@angular/common/http"; 

import firebase from "firebase";
import "firebase/firestore";

let config = {
  apiKey: "AIzaSyBJeVvuayLl4fO-W-Zut5OR-3Qdg5KJsPk",
  authDomain: "happydocs-18854.firebaseapp.com",
  projectId: "happydocs-18854",
  storageBucket: "happydocs-18854.appspot.com",
  messagingSenderId: "75193287702",
  appId: "1:75193287702:web:c114c08d6791b16bada137",
  measurementId: "G-9DGB89XZH9"
};

firebase.initializeApp(config);

export default firebase.firestore();

@NgModule({
  declarations: [
    AppComponent,
    NgxSignPdfComponent,
    ModalComponent,
    SideNavComponent,
    HeaderComponent,
    SideNavContentComponent, 
    SelectionAreaComponent 
  ],
  imports: [
    BrowserModule,
    PdfViewerModule,
    DragDropModule,
    HttpClientModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent] 
})
export class AppModule { } 


